import type { ApiS3FileId } from 'api/types/ApiTypedId';

type Args = {
  fileId: ApiS3FileId;
  downloadAttachment: boolean;
};

export function apiS3FileIdToUrl({ fileId, downloadAttachment }: Args) {
  return `/data/s3-uploads/${fileId}?download=${downloadAttachment.toString()}`;
}
